<search-list-new
  matSort
  [defaultSort]="{
    active: 'dueDate',
    direction: 'asc'
  }"
  [showManagerToggle]="false"
  [pageSize]="12"
  [displayedColumns]="displayedColumns"
  [resultGetter]="search.bind(this)"
  (itemSelected)="onSelect($event)"
  [localStorageId]="'procurement-queue'"
  [filterParams]="filterParams"
  [defaultFilters]="defaultFilters"
  [hideGroupByColumn]="false"
  [groupableFields]="[null, { name: 'dueDate', title: 'Due Date' }, { name: 'ticket', title: 'Source Ticket' }]"
  [defaultGrouping]="'dueDate'"
  [groupHeaderClassPredicate]="groupHeaderClassPredicate.bind(this)"
>
  <ng-content select="[preSearchContent]" preSearchContent></ng-content>

  <ng-container matColumnDef="ticketType">
    <mat-header-cell *matHeaderCellDef mat-sort-header="ticketType" style="flex-grow: 0; flex-basis: 10%">Type</mat-header-cell>
    <mat-cell *matCellDef="let row" style="flex-grow: 0; flex-basis: 10%;">
      <mat-chip class="button-text" disableRipple [ngClass]="getTicketTypeClass(row.ticketType)">
        {{getTicketTypeText(row.ticketType)}}
      </mat-chip>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="item">
    <mat-header-cell *matHeaderCellDef class="flex-grow-2">Item</mat-header-cell>
    <mat-cell *matCellDef="let row" class="flex-grow-2">
        <item-type-chip [item]="convertItemForChip(row)" class="mr-2"></item-type-chip> 
        <b>{{getItemName(row)}}</b>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="quantity">
    <mat-header-cell *matHeaderCellDef mat-sort-header="quantity" class="flex-grow-0 flex-shrink-1" style="min-width: 5%;">Quantity</mat-header-cell>
    <mat-cell *matCellDef="let row" class="flex-grow-0 flex-shrink-1 text-right" style="min-width: 5%;">
        <ng-container *ngIf="row.ticketType == 0">
          <span class=text-muted>{{getTotalAssignmentQty(row)}}</span>/<b>{{row.quantity}}</b>
        </ng-container>
        <ng-container *ngIf="row.ticketType == 1">
          {{row.quantity}}
        </ng-container>
    </mat-cell>
  </ng-container>
  
  <ng-container matColumnDef="sourceTicket">
    <mat-header-cell *matHeaderCellDef mat-sort-header="sourceTicket">Source Ticket</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <span>
        {{getSourceTicketName(row)}}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="dueDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header="dueDate" class="flex-grow-0" style="min-width: 8%;">Due Date</mat-header-cell>
    <mat-cell *matCellDef="let row" class="flex-grow-0" style="min-width: 8%;">
      <span class="font-weight-bold">
        {{row.dueDate | date }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="validity">
        <mat-header-cell *matHeaderCellDef mat-sort-header="validity" style="flex-grow: 0; flex-basis: 10%">Validity</mat-header-cell>
    <mat-cell *matCellDef="let row" style="flex-grow: 0; flex-basis: 10%;">
      <mat-chip *ngIf="row.validity !== null" class="button-text" disableRipple [ngClass]="getValidityClass(row.validity)">
        {{getValidityName(row.validity)}}
      </mat-chip>
    </mat-cell>

  </ng-container>


  <ng-template #groupHeaderTemplate let-item>
    <div class="d-flex align-items-center">
    <span class="group-header">{{ item.groupName }}</span>
    <!-- <span class="ml-2 small">
      {{ item.items.length }} item{{item.items.length === 1 ? '' : 's'}}
    </span> -->
    </div>
  </ng-template>
</search-list-new>

<ng-template #none>
  <span class="text-muted">—</span>
</ng-template>